/**
 * Tester-release UI: hide unfinished advanced surfaces while core journey is validated.
 * Set REACT_APP_TESTER_RELEASE=false to show full product chrome in dev.
 */
export const TESTER_SIMPLIFIED_UI =
  process.env.REACT_APP_TESTER_RELEASE !== 'false';

/**
 * Core journey UI (Stage 1): People → Memories → Legacy Book.
 * Hides pillar workspaces and advanced nav from primary surfaces.
 * Set REACT_APP_CORE_JOURNEY_UI=false to restore full product navigation.
 */
export const CORE_JOURNEY_UI =
  process.env.REACT_APP_CORE_JOURNEY_UI !== 'false';

/**
 * Tree-level HTML Legacy Book preview (Stage 3B). Hidden/soft-linked until stable.
 * Set REACT_APP_LEGACY_BOOK_HTML_PREVIEW=false to hide.
 */
export const LEGACY_BOOK_HTML_PREVIEW =
  process.env.REACT_APP_LEGACY_BOOK_HTML_PREVIEW !== 'false';

/**
 * Experimental Playwright HTML→PDF export button (Stage 3C). Off unless build flag set.
 * Set REACT_APP_LEGACY_BOOK_PLAYWRIGHT_EXPORT=true to show in dev/staging only.
 */
export const LEGACY_BOOK_PLAYWRIGHT_EXPORT =
  process.env.REACT_APP_LEGACY_BOOK_PLAYWRIGHT_EXPORT === 'true';


/** Chart layouts that are not reliable enough for testers yet. */
export const CHART_LAYOUTS_COMING_SOON = new Set(['pedigree', 'fan']);

/**
 * DNA upload stays available for internal testing. Set REACT_APP_DNA_VISIBLE=false to hide.
 * When tester-simplified UI is on, DNA is shown with a Beta label.
 */
export const DNA_UPLOAD_VISIBLE = process.env.REACT_APP_DNA_VISIBLE !== 'false';
